var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","absolute":"","color":"transparent"}},[_c('v-spacer'),_c('span',{staticClass:"font-weight-light pr-4"},[_vm._v("Privacy Policy")]),_c('span',{staticClass:"caption"},[_vm._v("© 2019 Pilviotus Oy")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }